import React from 'react'
import "./BybTermsCondition.css"
import HeaderNavbar from '../BybNavbar/HeaderNavbar'
import BybFooter from '../BybFooter/BybFooter'
function BybTermsCondition() {
  return (
    <>
            <HeaderNavbar/>

        <section className='byb-termscondition'>
        <div className='container'>
            <div className='byb-termscondition-header'>
            <h4>Terms and Conditions</h4>
            </div>
           
<div className='termscondition-content'>
<h6>Introduction</h6>
<p>Welcome to the ‘Brew Your Brand’ website. By purchasing our Brand Audit Kit, you agree to the following terms and conditions, which govern your use of our services and your interaction with our products. Please read these terms carefully before placing an order.</p>

<h6>Scope of Services</h6>
<p>The Brew Your Brand - Brand Audit Kit is a product providing tools and templates for conducting a brand audit. Digital downloads, memberships, or accounts are not required for purchase. Any sample audit tools or materials provided are for promotional purposes only.</p>

<h6>Product Orders</h6>
<ul>
    <li>The information we collect is used to:</li>
    <li>All sales are final upon completion of the purchase, as each kit is produced per order</li>
    <li>Payment for the Brand Audit Kit can be made through available digital payment options at checkout.</li>
    <li>Prices and availability of our products are subject to change without notice</li>

</ul>


    <h6>User Conduct and Indemnity</h6>
    <p>By using the Brew Your Brand website, you agree not to engage in any activities that are fraudulent, abusive, or that may harm or disrupt the operation of our website or services. You also agree to indemnify, and hold Brew Your Brand harmless from any liability, claims, or expenses, including legal fees, arising from misuse of the Brand Audit Kit, whether by you or any third party to whom you may provide the kit.</p>

<h6>Compliance and Legal Enforcement</h6>
<p>Unauthorised use, distribution, or reproduction of any materials in the Brew Your Brand - Brand Audit Kit without prior written approval or a No Objection Certificate (NOC) constitutes a breach of the license terms. Any such misuse will result in penalties under the Indian Copyright Act and other applicable laws. Brew Your Brand reserves the right to take legal action, including seeking damages and pursuing injunctive relief, to prevent unauthorised usage.</p>

<h6>Intellectual Property and Confidentiality</h6>
<p>1. Ownership: All materials within the Brand Audit Kit, including but not limited to templates, graphics, written content, and designs, are proprietary to Brew Your Brand and are protected by copyright, trademark, and other intellectual property laws.</p>

<p>2. License for Personal Use: Brew Your Brand grants you a limited, non-exclusive, non-transferable, and revocable license to use the contents of the Brand Audit Kit for personal or internal business purposes only. You agree not to distribute, modify, reproduce, or publicly display any part of the kit for commercial use without prior written consent.</p>

<p>3. Confidentiality Obligation: By purchasing and using the Brand Audit Kit, you agree to treat all contents, methodologies, and information as confidential. You are prohibited from disclosing, sharing, or otherwise distributing any part of the kit’s content to third parties without prior written authorization from Brew Your Brand.</p>

<p>4. No Reverse Engineering: You agree not to reverse engineer, decompile, or disassemble any part of the Brand Audit Kit to recreate similar products or services.</p>

<h6>Invoicing and Taxes</h6>
<p>The billed amount for each order of the Brew Your Brand - Brand Audit Kit includes all applicable taxes and shipping charges. Brew Your Brand provides a detailed invoice with every purchase, reflecting the full amount due, inclusive of all charges related to product delivery and handling.</p>

<h6>Modification of Terms</h6>
<p>Brew Your Brand reserves the right to update or modify these terms and conditions as needed. Significant changes will be communicated through our website. By continuing to use our services, you accept any revised terms.</p>

<h6>User-Generated Content and Testimonials</h6>
<p>Customer feedback and testimonials collected via email or phone may be displayed on the website with explicit customer consent. By providing a testimonial, you agree to Brew Your Brand’s right to display your feedback for promotional purposes.</p>

<h6>Limitation of Liability</h6>
<p>Brew Your Brand is not liable for any indirect, incidental, or consequential damages that may arise from the use or inability to use the Brand Audit Kit. Our liability is limited to the amount paid for the product.</p>

<h6>Dispute Resolution</h6>
<p>Any disputes arising under these terms shall first be attempted to be resolved through mediation. If mediation is unsuccessful, the dispute may be resolved through arbitration in Bangalore, Karnataka, India, in accordance with applicable laws.</p>

<h6>Jurisdiction</h6>
<p>These terms and conditions are governed by the laws of Bangalore, Karnataka, India. Any disputes arising from these terms will be resolved in the courts of Bangalore, Karnataka.</p>

<h6>Contact Information</h6>
<p>For privacy-related inquiries, please contact us at <a href="mailto:support@brewyourbrand.in"> support@brewyourbrand.in</a></p>
</div>




        </div>
        
        
        </section> 
        <BybFooter/>

    </>
  )
}

export default BybTermsCondition
